import axios from 'axios';
import store from '../redux/store';
import { SENHA_TROCA_OBRIGATORIA } from '../constants';
import { setSenhaPendenteAction } from '../redux/sessao/sessaoActions';

const api = axios.create({ timeout: 40000, withCredentials: true });

export function getUrlAtiva() {
  const state = store.getState();
  return state.cfgGeral.urlRemota;
}

api.interceptors.request.use(async (config) => {
  const state = store.getState();

  config.baseURL = getUrlAtiva();

  const token = state.sessao.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const codigoEmpresa = state.sessao.empresa?.codigoEmpresa;
  if (codigoEmpresa) {
    config.headers.codigo_empresa = codigoEmpresa;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.data instanceof ArrayBuffer) {
      const text = new TextDecoder('utf-8').decode(error.response.data);
      try {
        const json = JSON.parse(text);
        error.response.data = json;
        error.message = json.message || error.message;
      } catch {
        error.message = text || error.message;
        error.response.data = { message: text };
      }
    }

    if (
      error.response?.status === 403 &&
      error.response?.data?.codigo === SENHA_TROCA_OBRIGATORIA
    ) {
      store.dispatch(setSenhaPendenteAction());
    }

    return Promise.reject(error);
  }
);

export default api;
